export enum ButtonVariant {
    PRIMARY,
    SECONDARY,
    TERTIARY
}

export enum ButtonType {
    BUTTON ='button',
    SUBMIT = 'submit',
    RESET = 'reset'
}

export enum ButtonSize {
    SMALL,
    BASE,
    LARGE
}
